/*
 * searchanise-adapter.js: CONTROL THEME ONLY (spec v1, see EVENT_SPEC.md)
 *
 * Translates what Searchanise does on the page into the same voomi_* events our new
 * search publishes, so both arms are measured identically. Needs no Searchanise code;
 * it only reads what Searchanise exposes on the page. Every hook below was verified
 * on voomisupply.com on 10/13/2026 (Searchanise widgets build 69982).
 *
 * Load right after voomi-track.js, in <head> of the control theme's layout:
 *   <script src="{{ 'voomi-track.js' | asset_url }}"></script>
 *   <script src="{{ 'searchanise-adapter.js' | asset_url }}"></script>
 *
 * Delete this file (and Searchanise) after the test. Nothing else depends on it.
 *
 * Searchanise hooks used (all verified):
 *   - document event 'Searchanise.Loaded' (native)             -> safe to attach
 *   - Searchanise.$(document) 'Searchanise.ResultsUpdated'     -> results/collection grid (re)rendered
 *     (jQuery event on Searchanise's PRIVATE jQuery copy, so addEventListener can't see it)
 *   - #snize_results .snize-product + .data('snize_item_data') -> tile + Shopify product_id
 *   - .snize-search-results-header "Showing N results for" / .snize-no-products-found
 *     "didn't match any results" -> result count (waits up to 15s for either; v2, 10/25/2026)
 *   - .snize-ac-results li.snize-product|.snize-suggestion|.snize-category -> dropdown items
 *   - URL params rb_<facet>=<value> on filter change          -> filter applied
 */
(function () {
  'use strict';
  if (window.__voomiSnizeAdapter) return;
  window.__voomiSnizeAdapter = true;
  var started = false;
  var lastSearchQuery = null;      // query we already reported on this page
  var filterSnapshot = null;       // rb_* params at last check
  var FALLBACK_MS = 10000;         // report from the DOM if ResultsUpdated never fires
  // Max wait for Searchanise to paint the count. Reports as soon as it's painted, so this only
  // matters on very slow loads (throttled test: results painted ~14s after the 10s fallback fired).
  var COUNT_WAIT_MS = 15000;
  function vt() { return window.voomiTrack; }
  function urlParam(name) {
    try { return new URLSearchParams(location.search).get(name); } catch (e) { return null; }
  }
  // rb_<facet>=<value> params -> { facet: [values] }. Multiple values may be '|'-joined.
  function rbParams() {
    var out = {};
    try {
      new URLSearchParams(location.search).forEach(function (v, k) {
        if (k.indexOf('rb_') !== 0) return;
        var facet = k.slice(3);
        String(v).split('|').forEach(function (val) {
          if (val === '') return;
          (out[facet] = out[facet] || []).push(val);
        });
      });
    } catch (e) {}
    return out;
  }
  function tiles() { return document.querySelectorAll('#snize_results .snize-product'); }
  // The count once Searchanise has painted it, or undefined while it hasn't yet.
  // v1 read this 50ms after ResultsUpdated and guessed when the header wasn't filled in yet:
  // no count when tiles were already up, and a false 0 when they weren't (10/25/2026).
  // Now 0 comes only from Searchanise's own "didn't match" message, never from an empty grid.
  function resultCount(q) {
    var box = document.getElementById('snize_results');
    if (!box) return undefined;
    var header = box.querySelector('.snize-search-results-header');
    var text = header ? header.innerText || '' : '';
    var m = text.match(/Showing\s+([\d,]+)\s+results?\s+for/i);
    // Skip a header still showing the previous query's count.
    if (m && mentions(text, q)) return parseInt(m[1].replace(/,/g, ''), 10);
    // On zero results the header stays an unrendered template ("Showing [count] results").
    var none = box.querySelector('.snize-no-products-found');
    var noneText = none ? none.innerText || '' : '';
    if (/didn.t match any results/i.test(noneText) && mentions(noneText, q)) return 0;
    return undefined;
  }
  function mentions(text, q) {
    var squash = function (s) { return String(s).toLowerCase().replace(/\s+/g, ' ').trim(); };
    return squash(text).indexOf(squash(q)) !== -1;
  }
  // Calls back with the count as soon as it's painted, or null after COUNT_WAIT_MS or when the
  // shopper leaves the page first (so the search is still recorded, without a guessed count).
  function whenCountReady(q, cb) {
    // Watch the whole body: on a slow load #snize_results may not exist yet, or may be replaced.
    var box = document.body;
    var done = false, observer = null, timer = null;
    function finish(n) {
      if (done) return;
      done = true;
      if (observer) observer.disconnect();
      clearTimeout(timer);
      window.removeEventListener('pagehide', onLeave);
      cb(n);
    }
    function onLeave() { var n = resultCount(q); finish(n === undefined ? null : n); }
    function check() { var n = resultCount(q); if (n !== undefined) finish(n); }
    try {
      observer = new MutationObserver(check);
      observer.observe(box, { childList: true, subtree: true, characterData: true });
    } catch (e) {}
    window.addEventListener('pagehide', onLeave);
    timer = setTimeout(function () { finish(null); }, COUNT_WAIT_MS);
    check();
  }
  function productIdFrom(el) {
    try {
      var d = window.Searchanise && window.Searchanise.$ && window.Searchanise.$(el).data('snize_item_data');
      if (d && d.product_id) return String(d.product_id);
    } catch (e) {}
    var a = el.querySelector && el.querySelector('a[href*="/products/"]');
    var href = a && a.getAttribute('href');
    return href ? 'handle:' + href.split('/products/')[1].split(/[?#]/)[0] : '';
  }
  function currentPage() {
    var p = parseInt(urlParam('page'), 10);
    return isNaN(p) || p < 1 ? 1 : p;
  }
  function typedQuery() {
    var a = document.activeElement;
    if (a && a.tagName === 'INPUT' && a.value) return a.value;
    var inputs = document.querySelectorAll('input[name="q"], #snize-mobile-search-input');  // + Searchanise mobile overlay (10/28/2026)
    for (var i = 0; i < inputs.length; i++) if (inputs[i].value) return inputs[i].value;
    return '';
  }
  // ---- search submitted ----------------------------------------------------
  function maybeReportSearch() {
    if (!vt() || vt().pageType() !== 'search') return;
    var q = (urlParam('q') || '').trim();
    if (!q || q === lastSearchQuery) return;
    lastSearchQuery = q;
    whenCountReady(q, function (n) {
      // Searchanise has no catalog-choices section: what it shows is its result count (10/27).
      vt().searchSubmitted({
        query: q,
        resultCount: n,
        shownAs: n === null ? '' : n > 0 ? 'results' : 'none',
        shownCount: n,
      });
    });
  }
  // ---- filters applied -----------------------------------------------------
  function maybeReportFilters() {
    var cur = rbParams();
    if (filterSnapshot === null) { filterSnapshot = cur; return; } // filters present on landing aren't "applied"
    Object.keys(cur).forEach(function (facet) {
      var before = filterSnapshot[facet] || [];
      cur[facet].forEach(function (val) {
        if (before.indexOf(val) === -1) {
          vt().filterApplied({ filterName: facet, filterValue: val, query: urlParam('q') || '' });
        }
      });
    });
    filterSnapshot = cur;
  }
  function onResultsUpdated() {
    // Let Searchanise finish painting the header before reading the count.
    setTimeout(function () { maybeReportSearch(); maybeReportFilters(); }, 50);
  }
  // ---- clicks (capture phase, so we see them before navigation) -------------
  function onClick(e) {
    if (!vt()) return;
    var t = e.target;
    if (!t || !t.closest) return;
    // Search dropdown
    var ac = t.closest('.snize-ac-results');
    if (ac) {
      var li = t.closest('li');
      if (!li || /snize-label|snize-separator/.test(li.className)) return;
      var type = /snize-product/.test(li.className) ? 'product'
        : /snize-suggestion/.test(li.className) ? 'suggestion'
        : /snize-categor/.test(li.className) ? 'category'
        : /snize-page/.test(li.className) ? 'page' : 'other';
      var group = type === 'other' ? [li] : ac.querySelectorAll('li.snize-' + (type === 'category' ? 'category' : type));
      var pos = Array.prototype.indexOf.call(group, li);
      var itemData = null;
      try { itemData = window.Searchanise.$(li).data('snize_item_data'); } catch (err) {}
      vt().autocompleteUsed({
        query: typedQuery(),
        itemType: type,
        itemText: (itemData && itemData.title) || (li.innerText || '').replace(/\s+/g, ' '),
        productId: type === 'product' ? productIdFrom(li) : '',
        position: pos === -1 ? null : pos + 1
      });
      return;
    }
    // Results / collection grid tile
    var tile = t.closest('#snize_results .snize-product');
    if (tile) {
      // Add-to-cart, quick-view, swatches and option pickers aren't result clicks.
      if (t.closest('button, select, input, .snize-button, .snize-add-to-cart-button, .snize-quick-view-button, .snize-swatches-container, .snize-color-swatch, .snize-size-select-box')) return;
      if (!t.closest('a')) return; // only clicks that navigate
      var idx = Array.prototype.indexOf.call(tiles(), tile);
      vt().resultClicked({
        productId: productIdFrom(tile),
        position: idx === -1 ? null : idx + 1,
        page: currentPage(),
        query: urlParam('q') || ''
      });
    }
  }
  // ---- start ---------------------------------------------------------------
  function start() {
    if (started || !window.Searchanise || !window.Searchanise.$) return;
    started = true;
    var $ = window.Searchanise.$;
    $(document).on('Searchanise.ResultsUpdated', onResultsUpdated);
    document.addEventListener('click', onClick, true);
    document.addEventListener('auxclick', onClick, true); // middle-click / open in new tab
    filterSnapshot = null;
    maybeReportFilters(); // take the landing snapshot
    // Fallback if ResultsUpdated fired before we attached, or never fires.
    setTimeout(maybeReportSearch, FALLBACK_MS);
  }
  document.addEventListener('Searchanise.Loaded', start);
  function poll() { if (window.Searchanise && window.Searchanise.Loaded) start(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', poll);
  else poll();
  window.addEventListener('load', poll);
  // ---- empty dropdown (10/28/2026) -------------------------------------------
  // voomi_search_dropdown_empty: the instant dropdown shows nothing to pick 1s after
  // the last edit to the box (so half-typed words don't count). Once per distinct
  // text per page. Tracking only; nothing visible changes.
  (function () {
    var SETTLE_MS = 1000;
    var sentEmpty = Object.create(null);
    var emptyTimer = null;
    // Searchanise: its dropdown is up and says "Sorry, nothing found".
    function dropdownEmpty() {
      var boxes = document.querySelectorAll('.snize-ac-results');
      for (var i = 0; i < boxes.length; i++) {
        if (boxes[i].offsetHeight && boxes[i].querySelector('li.snize-nothing-found') &&
            !boxes[i].querySelector('li.snize-product, li.snize-suggestion, li.snize-category, li.snize-page')) return true;
      }
      return false;
    }
    function settled(input) {
      emptyTimer = null;
      try {
        var text = (input.value || '').trim();
        if (!text || !dropdownEmpty()) return;
        var key = text.toLowerCase();
        if (sentEmpty[key] || !vt()) return;
        sentEmpty[key] = true;
        vt()._publish('search_dropdown_empty', { query: text });
      } catch (e) { /* tracking must never break the page */ }
    }
    // Restart the 1s clock on every edit. The new search cancels the native 'input'
    // event and writes the box itself, so 'beforeinput' is the edit signal there;
    // 'input' covers Searchanise. The text is read when the clock runs out.
    function onEdit(e) {
      var input = e.target;
      if (!input || input.tagName !== 'INPUT' || (input.name !== 'q' && input.id !== 'snize-mobile-search-input')) return;  // + mobile overlay (10/28/2026)
      if (emptyTimer) clearTimeout(emptyTimer);
      emptyTimer = setTimeout(function () { settled(input); }, SETTLE_MS);
    }
    document.addEventListener('beforeinput', onEdit, true);
    document.addEventListener('input', onEdit, true);
  })();
  // ---- tracking plan batch A (10/28/2026) ----------------------------------------
  // Listeners sit on WINDOW capture: the new search stops focusin/keydown there, so
  // document-level listeners never see them on that arm (verified 10/28).
  // Same block appended to BOTH live files (new-search bridge on t/170, Searchanise adapter
  // on t/168), so both arms are measured by literally the same code. Only the SEL table
  // differs per arm. Tracking only; nothing visible changes. Every field rides a column the
  // live pixel already forwards for custom events (query, result_count, product_id, position,
  // page, surface, item_type, item_text, filter_name, filter_value); anything else, e.g.
  // `quantity`, is dropped by the pixel (verified 10/28), so no pixel/collector change.
  //
  //   voomi_search_box_engaged    item_type 'focus' | 'typed'; once each per page view
  //   voomi_search_results_rendered  every paint of the results grid (first load, page,
  //       sort, filter): query, page, result_count (total), item_type (results |
  //       catalog_choices | none), item_text (top 10 product ids on the page, in order),
  //       position (ms to paint: from navigation start on the first render, from the
  //       shopper's last click/key on re-renders), filter_name 'sort' + filter_value (sort key)
  //   voomi_search_dropdown_shown  the instant dropdown settles (1s) with something in it:
  //       query, item_text (product ids, in order, max 10), result_count (# products),
  //       position (# query suggestions), page (# categories/brands), filter_value
  //       (suggestion + category texts, 's:..|c:..', max 300 chars)
  //   voomi_autocomplete_keyboard (control only): keyboard picks (arrow + Enter), same fields
  //       as voomi_autocomplete_used. The Searchanise adapter misses these today; the new
  //       search already counts them as clicks. Own event name, so the locked funnel (which
  //       counts voomi_autocomplete_used) doesn't change definition mid-window.
  (function () {
    // Once per document: the test theme's page also requests t/168's adapter during
    // Elevate's redirect (10/28), so never let two copies run on one page.
    if (window.__voomiAbExt) return;
    window.__voomiAbExt = true;
    var SNIZE = !!window.__voomiSnizeAdapter;
    var SEL = SNIZE ? {
      results: '#snize_results',
      tile: '#snize_results .snize-product',
      tileId: function (el) { var m = /snize-product-(\d+)/.exec(el.id || ''); return m ? m[1] : ''; },
      catalogChoice: null,
      empty: '#snize_results .snize-no-products-found',
      total: function () {
        var h = document.querySelector('#snize_results .snize-search-results-header');
        var m = h && /Showing\s+([\d,]+)\s+results?/i.exec(h.innerText || '');
        return m ? parseInt(m[1].replace(/,/g, ''), 10) : null;
      },
      page: function () { var a = document.querySelector('.snize-pagination a.active'); return a ? parseInt(a.getAttribute('rev'), 10) || 1 : 1; },
      sort: function () { var b = document.querySelector('.snize-main-panel-dropdown-button span'); return b ? (b.innerText || '').trim().toLowerCase() : ''; },
      dropdown: function () {
        var boxes = document.querySelectorAll('.snize-ac-results');
        for (var i = 0; i < boxes.length; i++) if (boxes[i].offsetHeight) return boxes[i];
        return null;
      },
      ddProducts: function (box) {
        return [].map.call(box.querySelectorAll('li.snize-product'), function (li) { return li.getAttribute('data-original-product-id') || ''; });
      },
      ddSuggestions: function (box) { return [].map.call(box.querySelectorAll('li.snize-suggestion'), text); },
      ddCategories: function (box) { return [].map.call(box.querySelectorAll('li.snize-category, li.snize-page'), text); }
    } : {
      results: '.voomi-search-results-main',
      tile: '.voomi-search-results-main a[data-voomi-product-id]',
      tileId: function (el) { return el.getAttribute('data-voomi-product-id') || ''; },
      catalogChoice: '[data-voomi-match-mode="catalog_candidate"]',
      empty: '.voomi-search-results-main .voomi-search-status--empty',
      total: function () {   // "Showing 1-24 of 1637 result(s)"; catalog choices / none show no count
        var h = document.querySelector('.voomi-search-results-main');
        var m = h && /of\s+([\d,]+)\s+result/i.exec(h.innerText || '');
        return m ? parseInt(m[1].replace(/,/g, ''), 10) : lastFound;
      },
      page: function () { var c = document.querySelector('.voomi-search-pagination__current'); return c ? parseInt(c.innerText, 10) || 1 : 1; },
      sort: function () { var o = document.querySelector('.voomi-search-sort__option--selected[data-sort-id]'); return o ? o.getAttribute('data-sort-id') : ''; },
      dropdown: function () { var p = document.getElementById('voomi-search-popover'); return p && p.offsetHeight ? p : null; },
      ddProducts: function (box) {
        return [].map.call(box.querySelectorAll('a[data-voomi-product-id]'), function (a) { return a.getAttribute('data-voomi-product-id'); });
      },
      // brand / collection links are refinements (= Searchanise categories); 'query' is "View all".
      ddSuggestions: function (box) {
        return [].map.call(box.querySelectorAll('[data-voomi-suggestion-kind]:not([data-voomi-suggestion-kind="query"]):not([data-voomi-suggestion-kind="brand"]):not([data-voomi-suggestion-kind="collection"])'), text);
      },
      ddCategories: function (box) {
        return [].map.call(box.querySelectorAll('[data-voomi-suggestion-kind="brand"], [data-voomi-suggestion-kind="collection"]'), text);
      }
    };
    var lastFound = null;   // new search: total from the app's results_shown event
    window.addEventListener('voomi:search', function (e) {
      var d = e && e.detail;
      if (d && d.event_type === 'results_shown' && d.surface !== 'autocomplete') lastFound = d.found != null ? d.found : null;
    });
    function text(el) { return (el.innerText || '').replace(/\s+/g, ' ').trim().slice(0, 60); }
    function uniq(a) { return a.filter(function (x, i) { return x && a.indexOf(x) === i; }); }
    function pub(name, data) { try { if (vt()) vt()._publish(name, data); } catch (e) { /* never break the page */ } }
    // The header box (name=q) on both arms, plus Searchanise's MOBILE overlay input: tapping
    // the header box on control mobile moves focus and typing to #snize-mobile-search-input,
    // which has no name (verified 10/28, iPhone UA).
    function isBox(el) {
      return !!el && el.tagName === 'INPUT' && (el.name === 'q' || el.id === 'snize-mobile-search-input');
    }
    function boxText() {
      var a = document.activeElement;
      if (isBox(a)) return (a.value || '').trim();
      var all = document.querySelectorAll('input[name="q"], #snize-mobile-search-input');
      for (var i = 0; i < all.length; i++) if (all[i].value) return all[i].value.trim();
      return '';
    }

    // ---- gap 1: box engaged (focus, first keystroke) -------------------------
    // Focus counts only when the shopper put it there (pointer or Tab), not a script.
    var engaged = { focus: false, typed: false };
    var lastUserInput = 0;
    function markUser() { lastUserInput = Date.now(); }
    window.addEventListener('pointerdown', markUser, true);
    window.addEventListener('keydown', function (e) { if (e.key === 'Tab') markUser(); }, true);
    window.addEventListener('focusin', function (e) {
      if (engaged.focus || !isBox(e.target) || Date.now() - lastUserInput > 1000) return;
      engaged.focus = true;
      pub('search_box_engaged', { item_type: 'focus' });
    }, true);
    function onFirstEdit(e) {
      if (engaged.typed || !isBox(e.target)) return;
      engaged.typed = true;
      pub('search_box_engaged', { item_type: 'typed' });
    }
    window.addEventListener('beforeinput', onFirstEdit, true);
    window.addEventListener('input', onFirstEdit, true);

    // ---- gaps 2 + 5 + sort/page: results rendered ----------------------------
    // Watches the grid; once tiles (or the empty message) are up and the DOM has been quiet
    // for 300ms, reports what is on the page. Re-reports only when the set changes (page,
    // sort, filter, new query). Paint time = when tiles first appeared for this render,
    // measured from navigation start (first render) or from the shopper's last click/tap
    // on the page (re-renders).
    if (vt() && vt().pageType() === 'search') {
      var firstRender = true, lastSig = '', paintAt = null, quietTimer = null, lastInteraction = 0, lastFirst = null;
      // What sits first in the grid right now ('' = nothing, '-' = the empty message).
      var firstId = function () {
        var t = document.querySelector(SEL.tile);
        if (t && t.offsetHeight) return SEL.tileId(t) || '?';
        var z = document.querySelector(SEL.empty);
        return z && z.offsetHeight ? '-' : '';
      };
      var touched = function () { lastInteraction = performance.now(); };
      window.addEventListener('pointerdown', touched, true);
      window.addEventListener('keydown', touched, true);
      var report = function () {
        quietTimer = null;
        try {
        var q = '';
        try { q = (new URLSearchParams(location.search).get('q') || '').trim(); } catch (e) {}
        if (!q) return;
        var tiles = document.querySelectorAll(SEL.tile);
        var empty = document.querySelector(SEL.empty);
        if (!tiles.length && !(empty && empty.offsetHeight)) return;
        var ids = uniq([].map.call(tiles, SEL.tileId)).slice(0, 10);
        var shownAs = !tiles.length ? 'none'
          : SEL.catalogChoice && document.querySelector(SEL.tile + SEL.catalogChoice) ? 'catalog_choices' : 'results';
        var page = SEL.page(), sort = SEL.sort();
        var sig = [q, page, sort, ids.join(',')].join('|');
        if (sig === lastSig) return;
        lastSig = sig;
        var start = firstRender ? 0 : lastInteraction;
        pub('search_results_rendered', {
          query: q, page: page, result_count: shownAs === 'none' ? 0 : SEL.total(), item_type: shownAs,
          item_text: ids.join(','), position: paintAt != null ? Math.max(0, Math.round(paintAt - start)) : null,
          filter_name: 'sort', filter_value: sort, surface: 'search'
        });
        firstRender = false;
        lastFirst = firstId();
        paintAt = null;
        } catch (e) { /* never break the page */ }
      };
      var watch = function () {
        var mo = new MutationObserver(function () {
          try {
          if (paintAt == null) {
            var f = firstId();
            if (f && f !== lastFirst) paintAt = performance.now();
          }
          if (paintAt != null) { clearTimeout(quietTimer); quietTimer = setTimeout(report, 300); }
          } catch (e) { /* never break the page */ }
        });
        mo.observe(document.body, { childList: true, subtree: true });
        setTimeout(function () { mo.disconnect(); }, 30 * 60 * 1000);   // stop watching after 30 min
      };
      if (document.body) watch(); else document.addEventListener('DOMContentLoaded', watch);
    }

    // ---- gap 3: dropdown shown -----------------------------------------------
    // Same 1s settle as voomi_search_dropdown_empty; fires only when something is listed,
    // so the two events never overlap. Once per distinct text per page.
    var sentShown = Object.create(null), shownTimer = null;
    function ddSettled() {
      shownTimer = null;
      try {
        var q = boxText(), box = SEL.dropdown();
        if (!q || !box || sentShown[q.toLowerCase()]) return;
        var prods = uniq(SEL.ddProducts(box)).slice(0, 10);
        var sugg = uniq(SEL.ddSuggestions(box)), cats = uniq(SEL.ddCategories(box));
        if (!prods.length && !sugg.length && !cats.length) return;   // empty: the other event
        sentShown[q.toLowerCase()] = true;
        var labels = sugg.map(function (s) { return 's:' + s; }).concat(cats.map(function (c) { return 'c:' + c; }));
        pub('search_dropdown_shown', {
          query: q, item_text: prods.join(','), result_count: prods.length,
          position: sugg.length, page: cats.length, filter_value: labels.join('|').slice(0, 300)
        });
      } catch (e) { /* never break the page */ }
    }
    function onDdEdit(e) {
      if (!isBox(e.target)) return;
      clearTimeout(shownTimer);
      shownTimer = setTimeout(ddSettled, 1000);
    }
    window.addEventListener('beforeinput', onDdEdit, true);
    window.addEventListener('input', onDdEdit, true);

    // ---- gap 6: keyboard picks in the Searchanise dropdown (control only) ------
    // Searchanise highlights a row (aria-activedescendant) and navigates on Enter without a
    // click, so the adapter's click hook never sees it. Report it the same way as a click.
    if (SNIZE) {
      window.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' || !isBox(e.target)) return;
        try {
        var id = e.target.getAttribute('aria-activedescendant');
        var li = id && document.getElementById(id);
        var ac = li && li.closest && li.closest('.snize-ac-results');
        if (!ac || /snize-label|snize-separator/.test(li.className)) return;
        var type = /snize-product/.test(li.className) ? 'product'
          : /snize-suggestion/.test(li.className) ? 'suggestion'
          : /snize-categor/.test(li.className) ? 'category'
          : /snize-page/.test(li.className) ? 'page'
          : /snize-view-all/.test(li.className) ? 'view_all' : 'other';
        var group = ac.querySelectorAll('li.snize-' + (type === 'category' ? 'category' : type));
        var pos = [].indexOf.call(group, li);
        pub('autocomplete_keyboard', {
          query: (e.target.value || '').trim(), item_type: type, item_text: text(li),
          product_id: type === 'product' ? (li.getAttribute('data-original-product-id') || '') : '',
          position: pos === -1 ? null : pos + 1
        });
        } catch (err) { /* never break the page */ }
      }, true);
    }
  })();
})();